<template>
  <a
    v-if="external || !href"
    :href="href"
    :rel="external ? 'noopener noreferrer' : null"
    :target="external ? '_blank' : null"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </a>

  <nuxt-link
    v-else
    :to="{path: localePath(path), hash}"
    @click.native="$emit('click')"
  >
    <slot></slot>
  </nuxt-link>
</template>

<script>
  export default {
    name: 'Link',
    props: {
      href: {
        type: String,
        default: ''
      },
      external: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      path() {
        return this.href.split('#')[0]
      },
      hash() {
        return this.href.split('#')[1]
      }
    }
  }
</script>